import request from '../../utils/request';

export function getPartners(params) {
  return request('/partners', {
    method: 'GET',
    params: params,
  });
}

export function getPartner(id) {
  return request(`/partners/${id}`, {
    method: 'GET',
  });
}

export function createPartner(data) {
  return request('/partners', {
    method: 'POST',
    data,
  });
}

export function updatePartner(data) {
  const id = data.id;
  delete data.id;
  return request(`/partners/${id}`, {
    method: 'PATCH',
    data,
  });
}

export function removePartner(id) {
  return request(`/partners/${id}`, {
    method: 'DELETE',
  });
}

// Partner Route History

export function getPartnerRoutes(partnerId, params) {
  return request(`/partners/${partnerId}/routes`, {
    method: 'GET',
    params,
  });
}

// Partner Item Types (nested under partner)

export function getPartnerItemTypes(partnerId) {
  return request(`/partners/${partnerId}/partner-item-types`, {
    method: 'GET',
  });
}

export function createPartnerItemType(partnerId, data) {
  return request(`/partners/${partnerId}/partner-item-types`, {
    method: 'POST',
    data,
  });
}

export function updatePartnerItemType(data) {
  const id = data.id;
  delete data.id;
  return request(`/partner-item-types/${id}`, {
    method: 'PATCH',
    data,
  });
}

export function removePartnerItemType(id) {
  return request(`/partner-item-types/${id}`, {
    method: 'DELETE',
  });
}

// Partner Items (individual trackable items under a type)

export function getPartnerItems(typeId, params) {
  return request(`/partner-item-types/${typeId}/partner-items`, {
    method: 'GET',
    params,
  });
}

export function createPartnerItem(typeId, data) {
  return request(`/partner-item-types/${typeId}/partner-items`, {
    method: 'POST',
    data,
  });
}

export function updatePartnerItem(data) {
  const id = data.id;
  delete data.id;
  return request(`/partner-items/${id}`, {
    method: 'PATCH',
    data,
  });
}

export function removePartnerItem(id) {
  return request(`/partner-items/${id}`, {
    method: 'DELETE',
  });
}

export function bulkCreatePartnerItems(typeId, serialNumbers) {
  return request(`/partner-item-types/${typeId}/partner-items/bulk`, {
    method: 'POST',
    data: { serialNumbers },
  });
}

// Partner Viewers (partner_viewer users)

export function getPartnerViewers(partnerId, params) {
  return request(`/partners/${partnerId}/viewers`, {
    method: 'GET',
    params,
  });
}

export function createPartnerViewer(partnerId, data) {
  return request(`/partners/${partnerId}/viewers`, {
    method: 'POST',
    data,
  });
}

export function updatePartnerViewer(partnerId, viewerId, data) {
  return request(`/partners/${partnerId}/viewers/${viewerId}`, {
    method: 'PATCH',
    data,
  });
}

export function removePartnerViewer(partnerId, viewerId) {
  return request(`/partners/${partnerId}/viewers/${viewerId}`, {
    method: 'DELETE',
  });
}

// Partner Viewer (read-only, scoped to authenticated user's partner)

export function getMyPartner() {
  return request('/partners/me', { method: 'GET' });
}

export function getMyPartnerItemTypes() {
  return request('/partners/me/item-types', { method: 'GET' });
}

export function getMyPartnerViewers() {
  return request('/partners/me/viewers', { method: 'GET' });
}

export function getMyPartnerRoutes(params) {
  return request('/partners/me/routes', { method: 'GET', params });
}

// Partner Stats

export function getPartnerStats(partnerId, period) {
  return request(`/partners/${partnerId}/stats`, {
    method: 'GET',
    params: { period },
  });
}

export function getMyPartnerStats(period) {
  return request('/partners/me/stats', {
    method: 'GET',
    params: { period },
  });
}

export function getGlobalStats(period, partnerIds) {
  const params = { period };
  if (partnerIds && partnerIds.length > 0) {
    params.partnerIds = partnerIds.join(',');
  }
  return request('/partners/global/stats', {
    method: 'GET',
    params,
  });
}

// Webhook Logs

export function getOrderWebhookLogs(orderCode) {
  return request(`/orders/${orderCode}/webhook-logs`, {
    method: 'GET',
  });
}

export function retryWebhookLog(orderCode, logId) {
  return request(`/orders/${orderCode}/webhook-logs/${logId}/retry`, {
    method: 'POST',
  });
}

// Collected Items

export function getPartnerCollectedItems(partnerId, params = {}) {
  return request(`/partners/${partnerId}/collected-items`, {
    method: 'GET',
    params,
  });
}
